export default {
  install: function (Vue, options) {
    Vue.prototype.$confirm = function confirm () {
      return this.$root.$children[0].$refs.confirm
    }
  }
}
